import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import MapView from "./components/MapView";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <header className="App-header">
          <MapView />
        </header>
      </div>
    </QueryClientProvider>
  );
}

export default App;
